import Cookie from '@shopify/marketing-assets/javascripts/helpers/cookie-helper';

export function setDismissedPopup(dismissedPopup) {
  Cookie.set('dismissedPopup', Boolean(dismissedPopup), {path: '/'});
}

export function getDismissedPopup() {
  return Cookie.get('dismissedPopup');
}
